export default __webpack_public_path__ + "static/media/bkg--location-3.605bfd72.jpg";